/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PlacementsRouteImport } from './routes/placements'
import { Route as PipelineRouteImport } from './routes/pipeline'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as InterviewsRouteImport } from './routes/interviews'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ComplianceRouteImport } from './routes/compliance'
import { Route as CommissionsRouteImport } from './routes/commissions'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JobsIndexRouteImport } from './routes/jobs.index'
import { Route as ClientsIndexRouteImport } from './routes/clients.index'
import { Route as CandidatesIndexRouteImport } from './routes/candidates.index'
import { Route as PortalVendorRouteImport } from './routes/portal.vendor'
import { Route as PortalClientRouteImport } from './routes/portal.client'
import { Route as JobsNewRouteImport } from './routes/jobs.new'
import { Route as JobsJobIdRouteImport } from './routes/jobs.$jobId'
import { Route as ClientsClientIdRouteImport } from './routes/clients.$clientId'
import { Route as CandidatesCandidateIdRouteImport } from './routes/candidates.$candidateId'
import { Route as AgentsAgentRouteImport } from './routes/agents.$agent'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PlacementsRoute = PlacementsRouteImport.update({
  id: '/placements',
  path: '/placements',
  getParentRoute: () => rootRouteImport,
} as any)
const PipelineRoute = PipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const InterviewsRoute = InterviewsRouteImport.update({
  id: '/interviews',
  path: '/interviews',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplianceRoute = ComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => rootRouteImport,
} as any)
const CommissionsRoute = CommissionsRouteImport.update({
  id: '/commissions',
  path: '/commissions',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsIndexRoute = JobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const CandidatesIndexRoute = CandidatesIndexRouteImport.update({
  id: '/candidates/',
  path: '/candidates/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalVendorRoute = PortalVendorRouteImport.update({
  id: '/portal/vendor',
  path: '/portal/vendor',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalClientRoute = PortalClientRouteImport.update({
  id: '/portal/client',
  path: '/portal/client',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsNewRoute = JobsNewRouteImport.update({
  id: '/jobs/new',
  path: '/jobs/new',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsJobIdRoute = JobsJobIdRouteImport.update({
  id: '/jobs/$jobId',
  path: '/jobs/$jobId',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsClientIdRoute = ClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => rootRouteImport,
} as any)
const CandidatesCandidateIdRoute = CandidatesCandidateIdRouteImport.update({
  id: '/candidates/$candidateId',
  path: '/candidates/$candidateId',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsAgentRoute = AgentsAgentRouteImport.update({
  id: '/agents/$agent',
  path: '/agents/$agent',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/audit': typeof AuditRoute
  '/commissions': typeof CommissionsRoute
  '/compliance': typeof ComplianceRoute
  '/dashboard': typeof DashboardRoute
  '/inbox': typeof InboxRoute
  '/interviews': typeof InterviewsRoute
  '/notifications': typeof NotificationsRoute
  '/pipeline': typeof PipelineRoute
  '/placements': typeof PlacementsRoute
  '/settings': typeof SettingsRoute
  '/agents/$agent': typeof AgentsAgentRoute
  '/candidates/$candidateId': typeof CandidatesCandidateIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/jobs/new': typeof JobsNewRoute
  '/portal/client': typeof PortalClientRoute
  '/portal/vendor': typeof PortalVendorRoute
  '/candidates/': typeof CandidatesIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/jobs/': typeof JobsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/audit': typeof AuditRoute
  '/commissions': typeof CommissionsRoute
  '/compliance': typeof ComplianceRoute
  '/dashboard': typeof DashboardRoute
  '/inbox': typeof InboxRoute
  '/interviews': typeof InterviewsRoute
  '/notifications': typeof NotificationsRoute
  '/pipeline': typeof PipelineRoute
  '/placements': typeof PlacementsRoute
  '/settings': typeof SettingsRoute
  '/agents/$agent': typeof AgentsAgentRoute
  '/candidates/$candidateId': typeof CandidatesCandidateIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/jobs/new': typeof JobsNewRoute
  '/portal/client': typeof PortalClientRoute
  '/portal/vendor': typeof PortalVendorRoute
  '/candidates': typeof CandidatesIndexRoute
  '/clients': typeof ClientsIndexRoute
  '/jobs': typeof JobsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/audit': typeof AuditRoute
  '/commissions': typeof CommissionsRoute
  '/compliance': typeof ComplianceRoute
  '/dashboard': typeof DashboardRoute
  '/inbox': typeof InboxRoute
  '/interviews': typeof InterviewsRoute
  '/notifications': typeof NotificationsRoute
  '/pipeline': typeof PipelineRoute
  '/placements': typeof PlacementsRoute
  '/settings': typeof SettingsRoute
  '/agents/$agent': typeof AgentsAgentRoute
  '/candidates/$candidateId': typeof CandidatesCandidateIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/jobs/new': typeof JobsNewRoute
  '/portal/client': typeof PortalClientRoute
  '/portal/vendor': typeof PortalVendorRoute
  '/candidates/': typeof CandidatesIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/jobs/': typeof JobsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/audit'
    | '/commissions'
    | '/compliance'
    | '/dashboard'
    | '/inbox'
    | '/interviews'
    | '/notifications'
    | '/pipeline'
    | '/placements'
    | '/settings'
    | '/agents/$agent'
    | '/candidates/$candidateId'
    | '/clients/$clientId'
    | '/jobs/$jobId'
    | '/jobs/new'
    | '/portal/client'
    | '/portal/vendor'
    | '/candidates/'
    | '/clients/'
    | '/jobs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/audit'
    | '/commissions'
    | '/compliance'
    | '/dashboard'
    | '/inbox'
    | '/interviews'
    | '/notifications'
    | '/pipeline'
    | '/placements'
    | '/settings'
    | '/agents/$agent'
    | '/candidates/$candidateId'
    | '/clients/$clientId'
    | '/jobs/$jobId'
    | '/jobs/new'
    | '/portal/client'
    | '/portal/vendor'
    | '/candidates'
    | '/clients'
    | '/jobs'
  id:
    | '__root__'
    | '/'
    | '/analytics'
    | '/audit'
    | '/commissions'
    | '/compliance'
    | '/dashboard'
    | '/inbox'
    | '/interviews'
    | '/notifications'
    | '/pipeline'
    | '/placements'
    | '/settings'
    | '/agents/$agent'
    | '/candidates/$candidateId'
    | '/clients/$clientId'
    | '/jobs/$jobId'
    | '/jobs/new'
    | '/portal/client'
    | '/portal/vendor'
    | '/candidates/'
    | '/clients/'
    | '/jobs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsRoute: typeof AnalyticsRoute
  AuditRoute: typeof AuditRoute
  CommissionsRoute: typeof CommissionsRoute
  ComplianceRoute: typeof ComplianceRoute
  DashboardRoute: typeof DashboardRoute
  InboxRoute: typeof InboxRoute
  InterviewsRoute: typeof InterviewsRoute
  NotificationsRoute: typeof NotificationsRoute
  PipelineRoute: typeof PipelineRoute
  PlacementsRoute: typeof PlacementsRoute
  SettingsRoute: typeof SettingsRoute
  AgentsAgentRoute: typeof AgentsAgentRoute
  CandidatesCandidateIdRoute: typeof CandidatesCandidateIdRoute
  ClientsClientIdRoute: typeof ClientsClientIdRoute
  JobsJobIdRoute: typeof JobsJobIdRoute
  JobsNewRoute: typeof JobsNewRoute
  PortalClientRoute: typeof PortalClientRoute
  PortalVendorRoute: typeof PortalVendorRoute
  CandidatesIndexRoute: typeof CandidatesIndexRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  JobsIndexRoute: typeof JobsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/placements': {
      id: '/placements'
      path: '/placements'
      fullPath: '/placements'
      preLoaderRoute: typeof PlacementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pipeline': {
      id: '/pipeline'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof PipelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/interviews': {
      id: '/interviews'
      path: '/interviews'
      fullPath: '/interviews'
      preLoaderRoute: typeof InterviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance': {
      id: '/compliance'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof ComplianceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/commissions': {
      id: '/commissions'
      path: '/commissions'
      fullPath: '/commissions'
      preLoaderRoute: typeof CommissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/': {
      id: '/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof JobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/candidates/': {
      id: '/candidates/'
      path: '/candidates'
      fullPath: '/candidates/'
      preLoaderRoute: typeof CandidatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/vendor': {
      id: '/portal/vendor'
      path: '/portal/vendor'
      fullPath: '/portal/vendor'
      preLoaderRoute: typeof PortalVendorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/client': {
      id: '/portal/client'
      path: '/portal/client'
      fullPath: '/portal/client'
      preLoaderRoute: typeof PortalClientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/new': {
      id: '/jobs/new'
      path: '/jobs/new'
      fullPath: '/jobs/new'
      preLoaderRoute: typeof JobsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/$jobId': {
      id: '/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof JobsJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$clientId': {
      id: '/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof ClientsClientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/candidates/$candidateId': {
      id: '/candidates/$candidateId'
      path: '/candidates/$candidateId'
      fullPath: '/candidates/$candidateId'
      preLoaderRoute: typeof CandidatesCandidateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$agent': {
      id: '/agents/$agent'
      path: '/agents/$agent'
      fullPath: '/agents/$agent'
      preLoaderRoute: typeof AgentsAgentRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsRoute: AnalyticsRoute,
  AuditRoute: AuditRoute,
  CommissionsRoute: CommissionsRoute,
  ComplianceRoute: ComplianceRoute,
  DashboardRoute: DashboardRoute,
  InboxRoute: InboxRoute,
  InterviewsRoute: InterviewsRoute,
  NotificationsRoute: NotificationsRoute,
  PipelineRoute: PipelineRoute,
  PlacementsRoute: PlacementsRoute,
  SettingsRoute: SettingsRoute,
  AgentsAgentRoute: AgentsAgentRoute,
  CandidatesCandidateIdRoute: CandidatesCandidateIdRoute,
  ClientsClientIdRoute: ClientsClientIdRoute,
  JobsJobIdRoute: JobsJobIdRoute,
  JobsNewRoute: JobsNewRoute,
  PortalClientRoute: PortalClientRoute,
  PortalVendorRoute: PortalVendorRoute,
  CandidatesIndexRoute: CandidatesIndexRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  JobsIndexRoute: JobsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
